@if (sessionStore.isLoaded()) {
    <router-outlet></router-outlet>
    <app-gallery-import-media-v2 />
}
